<template>
  <div class="whole-grid">
    <c-data-grid
      :store="store"
      pagination
      :pageNum="pagination.pageNum"
      :pageSize="pagination.pageSize"
      :customSort="onSort"
    >
      <template v-for="column in structures">
        <!--显示控制列单元格-->
        <c-grid-column
          v-if="column.field === '_'"
          :field="column.field"
          :key="column.title"
          :fix="column.fix"
          :title="column.title"
          :sortAble="column.sortAble"
          :width="column.width"
        >
          <div
            class="select-cell"
            slot-scope="{ data, row, field }"
            @click="onSelect(data, row, field)"
          >
            <span class="select-btn" :style="getColor(data, row)"></span>
          </div>
        </c-grid-column>
        <!--人数单元格-->
        <c-grid-column
          v-else-if="
            column.fix !== 'left' &&
              ['add', 'active', 'duration'].indexOf(target.value) > -1 &&
              !showInPanel
          "
          :field="column.field"
          :key="column.title"
          :fix="column.fix"
          :title="column.title"
          :sortAble="column.sortAble"
          @clickCell="toUserInfo"
          :width="column.width"
        >
          <span class="header_" slot-scope="{ title }" slot="header">
            {{ headFormat(title) }}
          </span>
          <div class="cell_" slot-scope="{ data, field }">
            <span
              class="eye-cel"
              v-if="
                !showInPanel &&
                  (target.value !== 'duration' || data.target === '活跃用户')
              "
            >
              <i class="icon-eye"></i>{{ getCellValue(data, field) }}
            </span>
            <template v-else>
              {{ getCellValue(data, field) }}
            </template>
          </div>
        </c-grid-column>
        <!--细分列-->
        <c-grid-column
          v-else-if="column.field === 'target' && queryParam.dimension_sub"
          :field="column.field"
          :key="column.title"
          :fix="column.fix"
          :title="column.title"
          :sortAble="column.sortAble"
          :width="column.width"
        >
          <copy-cell
            slot-scope="{ data, field }"
            :label="data[field]"
          ></copy-cell>
        </c-grid-column>
        <!--指标列（活跃用户、新增用户等）-->
        <c-grid-column
          v-else
          :field="column.field"
          :key="column.title"
          :fix="column.fix"
          :title="column.title"
          :sortAble="column.sortAble"
          :width="column.width"
        >
          <span class="header_" slot-scope="{ title }" slot="header">
            {{ headFormat(title) }}
          </span>
          <span slot-scope="{ data, field }">
            {{ getCellValue(data, field) }}
          </span>
        </c-grid-column>
      </template>
    </c-data-grid>
    <c-pagination
      v-if="store.length"
      :total="metaData.series.length"
      :default-page-num="pagination.pageNum"
      :defaultPageSize="pagination.pageSize"
      :pageSizeOptions="[10, 25, 50, 100]"
      @change="onPagination"
    >
      <template slot="left" v-if="!showInPanel">
        <c-button
          size="normal"
          icon="icon-download"
          style="float: left"
          @click="onDownload"
        >
          导出
        </c-button>
      </template>
    </c-pagination>
  </div>
</template>

<script>
import { base64, util } from '../../utils'
import { actions } from '../../store/constants'
import { storageKey } from '../../constants'
import { mapState } from 'vuex'
import CopyCell from './copyCell'

export default {
  name: 'wholeGrid',
  components: { CopyCell },
  props: {
    metaData: null,
    dimension: {
      type: String
    },
    target: null,
    selectAble: {
      type: Boolean,
      default: true
    },
    /**
     * @description 是否是在看板中展示
     */
    showInPanel: {
      type: Boolean,
      default: false
    },
    queryParam: null,
    lastSelected: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      pagination: {
        pageNum: 1,
        pageSize: 10
      },
      selected: []
    }
  },
  computed: {
    /**
     * 选中的条目数
     * @returns {number}
     */
    selectCount () {
      if (this.queryParam.dimension_sub) {
        if (this.queryParam.chartType === 'line') return 3
        if (this.queryParam.chartType === 'bar') return 10
      }
      if (this.queryParam.chartType === 'pie') return 10
      return 5
    },
    ...mapState({
      bizDimensionIdMap (state) {
        let list = state.bizSys.eventEnvs.concat(state.bizSys.userProps)
        let map = {}
        list.forEach(dimension => {
          map[dimension.dimensionId] = dimension
        })
        return map
      }
    }),
    dimensionTitle () {
      // 解决细分列标题显示错误的问题
      // 细分获取优先级：dimesion属性、根据queryParam查找bizDimensionIdMap、直接获取queryParam
      let dimensionObj = {
        value: this.queryParam.user_attr || this.queryParam.dimension_sub,
        dimension_sub: this.queryParam.dimension_sub
      }
      let dimensionId = [dimensionObj.dimension_sub, dimensionObj.value].join(
        ','
      )
      return (
        this.dimension ||
        (this.bizDimensionIdMap[dimensionId] || {}).label ||
        dimensionObj.value
      )
    },
    haveUserGroup () {
      return this.queryParam.user_group !== '0'
    },
    structures () {
      let res = []
      if (
        !this.showInPanel &&
        (this.selectAble || this.target.value === 'duration') &&
        !/map/.test(this.queryParam.chartType)
      ) {
        res.push({
          field: '_',
          title: '显示',
          fix: 'left',
          sortAble: true
        })
      }
      if (this.haveUserGroup) {
        res.push({
          field: 'userGroup',
          title: '用户群',
          fix: 'left',
          downloadField: true,
          sortAble: true
        })
      }
      res.push({
        field: 'target',
        title: this.dimensionTitle || '指标',
        fix: 'left',
        downloadField: true,
        sortAble: true
      })
      this.metaData.x_axis.forEach(axis => {
        res.push({
          field: axis,
          title: axis,
          fix: 'center',
          sortAble: true
        })
      })
      if (!this.metaData.x_axis.length) {
        return []
      }
      return res
    },
    store () {
      let store = []
      this.metaData.series.forEach(row => {
        let item = {
          names: row.names
        }
        if (this.haveUserGroup) {
          item.userGroup = row.names[0]
          item.target = row.names[1]
        } else {
          item.target = row.names[0]
        }
        this.metaData.x_axis.forEach((field, i) => {
          item[field] = row.values[i]
        })
        store.push(item)
      })
      return store
    }
  },
  beforeMount () {
    let queryParam = {
      appId: this.queryParam.app_id,
      platform: this.queryParam.platform
    }
    // 查询属性细分原始列表，用于列表获取属性细分信息
    this.$store
      .dispatch(actions.biz.sys.queryEnvMeta, queryParam)
      .catch(error => {
        if (error.__CANCEL__) return
        console.log('获取时间触发环境失败')
      })
    this.$store
      .dispatch(actions.biz.sys.queryUserProps, queryParam)
      .catch(error => {
        if (error.__CANCEL__) return
        console.error('获取用户属性失败')
      })
  },
  mounted () {
    if (this.checkKeepSelect()) {
      let result = []
      let nameMap = {}
      this.lastSelected.forEach(item => {
        nameMap[item.join('-')] = item
      })
      this.store.forEach(item => {
        if (nameMap[item.names.join('-')]) {
          result.push(item)
        }
      })
      this.selected = result
      return
    }
    let groupMap = {}
    this.store.forEach((item, i) => {
      if (this.haveUserGroup && this.queryParam.chartType === 'pie') {
        if (!groupMap[item.names[0]]) {
          groupMap[item.names[0]] = []
        }
        if (groupMap[item.names[0]].length < this.selectCount) {
          groupMap[item.names[0]].push(item)
          this.selected.push(item)
        }
      } else {
        if (i < this.selectCount) {
          this.selected.push(item)
        }
      }
    })
    this.$emit('select', this.selected)
  },
  methods: {
    checkKeepSelect () {
      let queryParamCacheStr = sessionStorage.getItem(
        storageKey.queryParamCacheStr
      )
      let result = false
      if (queryParamCacheStr) {
        let queryParam = JSON.parse(queryParamCacheStr)
        // 当下面这些条件不变时，选中的列数不变
        let keyNames = [
          'app_id',
          'platform',
          'user_group',
          'dimension_sub',
          'filter_condition',
          'analysis_index',
          'chartType',
          'module'
        ]
        result = true
        keyNames.forEach(item => {
          if (
            JSON.stringify(queryParam[item]) !==
            JSON.stringify(this.queryParam[item])
          ) {
            result = false
          }
        })
        // 无选中项时不保持上次选中列，避免被上次的空值(无数据/取消选中项)影响
        if (!this.lastSelected || !this.lastSelected.length) {
          result = false
        }
      }
      sessionStorage.setItem(
        storageKey.queryParamCacheStr,
        JSON.stringify(this.queryParam)
      )
      return result
    },
    headFormat (title) {
      let res = title.replace(/\d{4}-/g, '').replace('|', '~')
      if (/:/.test(res)) {
        // 按小时
        res = res.replace(/\d{2}-\d{2}\s/, '')
      }
      return res
    },
    getColor (data) {
      let style = {}
      if (this.haveUserGroup && this.queryParam.chartType === 'pie') {
        let groupMap = {}
        this.selected.forEach(item => {
          if (!groupMap[item.names[0]]) {
            groupMap[item.names[0]] = []
          }
          groupMap[item.names[0]].push(item)
        })
        groupMap[data.names[0]].forEach((item, i) => {
          if (data.names.join('') === item.names.join('')) {
            style.background = this.$util.colors[i]
          }
        })
      } else {
        this.selected.forEach((item, i) => {
          if (data.names.join('') === item.names.join('')) {
            style.background = this.$util.colors[i]
          }
        })
      }
      return style
    },
    onSelect (data) {
      let exist = false
      this.selected.forEach((item, i) => {
        if (item.names.join('') === data.names.join('')) {
          // 取消选中操作
          exist = true
          this.selected.splice(i, 1)
        }
      })

      if (!exist) {
        // 选中操作
        this.selected.push(data)
      }
      this.$emit('select', this.selected)
    },
    onPagination (pagination) {
      this.pagination = pagination
    },
    onDownload () {
      let queryParam = this.$util.clone(this.queryParam)
      let targetName = this.target.name
      queryParam.down = {
        fname: base64.encode('整体_' + targetName),
        titles: []
      }
      this.structures.forEach(column => {
        if (!column.downloadField) return
        queryParam.down.titles.push(base64.encode(column.title))
      })
      queryParam.down = JSON.stringify(queryParam.down)
      let params = []
      for (let prop in queryParam) {
        let val = queryParam[prop]
        params.push(`${prop}=${val}`)
      }
      let url = `/data/downloadReport.jsp?${params.join('&')}`
      let iframe = document.createElement('iframe')
      iframe.setAttribute(
        'style',
        'position: fixed;top:-10000000px;width:0;height:0;border:0;margin:0;padding:0;'
      )
      document.body.appendChild(iframe)
      iframe.setAttribute('src', url)
    },
    getCellValue (data, field) {
      if (['userGroup', 'target'].includes(field)) {
        if (field === 'target' && data[field] === '使用时长') {
          return '平均使用时长'
        }
        return data[field]
      } else if (this.queryParam.module === 'duration_avg') {
        return util.timeFormat(data[field], 'hhhmmmsss', true)
      } else {
        return this.$util.toThousands(data[field])
      }
    },
    onSort (a, b, field, status) {
      if (field === '_') {
        let chosenA = false
        let chosenB = false
        this.selected.forEach(item => {
          if (item.names.join('') === a.names.join('')) chosenA = true
          if (item.names.join('') === b.names.join('')) chosenB = true
        })
        if (chosenA) {
          return 1 * status
        } else if (chosenB) {
          return -1 * status
        }
      } else {
        if (a[field] > b[field]) {
          return 1 * status
        } else if (a[field] < b[field]) {
          return -1 * status
        }
      }
      return 0
    },
    toUserInfo (data, field) {
      if (
        this.showInPanel ||
        (this.target.value === 'duration' && data.target !== '活跃用户')
      ) { return }
      this.$emit('detail', data, field)
    }
  }
}
</script>

<style lang="sass">
@import "styles/grid"
</style>
